/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { Alert } from '@vamstar/fox-frontend-common';

import { ElasticDslEntitlementContext } from './ElasticDslEntitlementContext';

export const ElasticDslQueryViewer = ({ disabled }: { disabled: boolean }) => {
  return (
    <ElasticDslEntitlementContext.Consumer>
      {({ query }) => {
        if (query) {
          return (
            <Box display="flex" flexDirection="column" rowGap={2}>
              <Box bgcolor="grey" width="100%" py={1} px={0.5}>
                <Typography variant="caption">Your query</Typography>
                {query.length === 0 ? (
                  <Typography color="GrayText">No query added</Typography>
                ) : (
                  <Typography fontFamily="monospace">{query}</Typography>
                )}
              </Box>
              {disabled ? (
                <Alert open severity="error">
                  Invalid lucene query
                </Alert>
              ) : (
                <></>
              )}
            </Box>
          );
        }
        return <></>;
      }}
    </ElasticDslEntitlementContext.Consumer>
  );
};
